import { withMotionMax } from '@hoc/withMotionMax';
import CarouselCard from '@stories/Components/Cards/CarouselCard/CarouselCard';
import Modal from '@stories/Components/Modal/Modal';
import * as React from 'react';
import S from './OurPeopleCarousel.styles';
const OurPeopleCarousel = (props) => {
    const [modalContent, setModelContent] = React.useState(props.items[0]);
    const [modalOpen, setModelOpen] = React.useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(S.Container, { "data-variant": props.variant },
            React.createElement(S.TitleArea, null, props.title && React.createElement(S.Title, null, props.title)),
            React.createElement(S.Grid, null, props.items.map((item) => (React.createElement(S.Item, { key: item.id },
                React.createElement(CarouselCard, { ...item, columnAmount: 4, size: props.cardSize || 'normal', setModelContent: (item) => setModelContent(item), setModelOpen: () => setModelOpen(!modalOpen) })))))),
        React.createElement(Modal, { content: modalContent, isVisible: modalOpen, onClick: () => {
                setModelOpen(false);
            } })));
};
export default withMotionMax(OurPeopleCarousel);
